import styled from 'styled-components';

export const BrowserNotSupportedStyled = styled.div`
	height: 100vh;
	width: 100%;
`;
